import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

export const useAdminPublishNomenclatures = () => {
  const queryClient = useQueryClient();

  return apiClient.nomenclature.publishTaricNomenclature.useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin-catalogs-info'] });
      toast.success('Nomenclatures published successfully');
    },
    onError: (error: unknown) => {
      showErrorToast(error, 'Failed to publish nomenclatures');
    },
  });
};
